const supported = typeof navigator !== 'undefined' && 'vibrate' in navigator

export const haptics = {
  tap:    () => supported && navigator.vibrate(10),
  bump:   () => supported && navigator.vibrate(20),
  ok:     () => supported && navigator.vibrate([15, 30, 15]),
  warn:   () => supported && navigator.vibrate([40, 20, 40]),
  err:    () => supported && navigator.vibrate([60, 40, 60, 40, 60]),
}
